import page from 'page'
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Overlay from '../../components/Overlay'
import { Helmet } from 'react-helmet'
import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import * as _ from 'recompose'
import { isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { fetchingState } from '../../helpers/hocs.js'
import Loader from '../../components/Loader'
import InnerHTML from 'script-inner-html'

import { pay, widgetPay } from '../../store/reducers/CP'

import { getIsLogged, getLoggedUser, getSettingsInfo } from '../../selectors/user.js'

import HelpForm from '../../components/CybersportHelpForm'

const Donate = ({ success = null, fetching, checkout, setSuccess }) => {

  return (
    <div className='Help'>
      <div>
        <div className='Container Container_no-top'>

          <div className='Container Container_light Container_white' style={{width: '65%'}}>
            <div className='Help-top'>
              <div className='Help__text-orange' style={{color: '#ff5027'}}>
                <b>Благотворительный шоу-матч по Dota-2 при поддержке
                Федерации компьютерного спорта города Москвы и Meet For Charity.
                </b>
              </div>
              <div className='Help__text'>
              Совершая пожертвование, вы поддерживаете подопечных фонда «Жизнь в движении»,
              помогающего в протезировании и социальной адаптации детей с ограниченными
              возможностями здоровья, и делаете вклад в развитие благотворительности.
              Благодарим за вашу помощь!
              </div>
              
            </div>
          </div>

          <div className='Help-bottom'>
            <div className='Container Container_light' style={{paddingRight: '0'}}>
              <Helmet>
                <title>Пожертвовать MFC</title>
              </Helmet>

              <HelpForm notRequired={{}}/>
              <div className="mfc-modal__thanks">
                <b>Спасибо!</b><br />
                #КаждыйВкладИмеетЗначение
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

const mapStateToProps = state => ({
  currentLocale: state.intl.locale,
  isLogged: getIsLogged(state),
  LoggedUser: getLoggedUser(state),
  SettingsInfo: getSettingsInfo(state),
  //...state.CP

})
const mapDispatchToProps = dispatch => bindActionCreators({ pay, widgetPay }, dispatch)
const mergeProps = (state, { pay, widgetPay }, { fetchingWrap, ...props }) => ({
  ...props,
  ...state,
})

export default injectIntl(compose(
  fetchingState(),//
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  fetchingState({ multi: true }),
  withHandlers({
  }),
  lifecycle({
    async componentWillMount() {
    },
    componentDidMount() {
    }
  }),
)(Donate))


// WEBPACK FOOTER //
// ./src/containers/Donate/CybersportHelp.jsx